import { render, staticRenderFns } from "./ApplicationHistory.vue?vue&type=template&id=6c047cb2"
import script from "./ApplicationHistory.vue?vue&type=script&lang=js"
export * from "./ApplicationHistory.vue?vue&type=script&lang=js"
import style0 from "./ApplicationHistory.vue?vue&type=style&index=0&id=6c047cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports